import * as spreadsheetApi from '@/services/spreadsheet.service'
import { productKeyMap, comboKeyMap, specificationKeyMap, comboSubItemsKeyMap, comboSubAnyKeyMap, comboSubAltKeyMap } from '@/static/docs/menuKeyMap'
import spreadSheetModel from '@/models/spreadSheet.model'
import commonUtils from "@/utils/common.utils";

export default {
    namespaced: true,
    state: {
        dineInTablesResponse: [],
        dineInTablesLoaded: false,
        categoriesResponse: [],
        productsResponse: [],
        combosResponse: [],
        specificationResponse: [],
        comboSubItemsResponse: [],
        comboSubAnyResponse: [],
        comboSubAltResponse: [],
        productComboSpecResponse: [],
        spreadSheetData: {}
    },
    getters: {
        isVip: (state, getters, rootState, rootGetters) => {
            return rootGetters['userData/vipLevel'] > 1
        },
        isAreaIdValid: (state, getters) => (areaId) => {
            if (!getters.dineInTables.length) return false
            return getters.dineInTables.find(area => area.areaId === areaId)
        },
        isTableIndexValid: (state, getters) => (areaId, tableIndex) => {
            if (!getters.dineInTables.length) return false
            // 如果沒有 tableIndex，且該區域沒有桌子，則回傳 true
            if (tableIndex == -1 && getters.dineInTables.find(area => area.areaId === areaId).tables.length === 0) {
                return true
            }
            return getters.dineInTables.find(area => area.areaId === areaId).tables[tableIndex]
        },
        tableName: (state, getters) => (areaId, tableIndex) => {
            if (!getters.dineInTables.length) return ''
            if (!getters.isAreaIdValid || !getters.isTableIndexValid) return ''
            const area = getters.dineInTables.find(area => area.areaId === areaId)
            if (tableIndex == -1) return area.name
            const tableName = area.tables[tableIndex] || ''
            return `${area.name}${tableName.name}`
        },
        dineInTables: (state) => {
            const result = [];
            let currentArea = null;
            for (const row of state.dineInTablesResponse) {
                if (row.length === 0) {
                    continue;
                }
                const [areaId, name, enable] = row;
                if (areaId) {
                    currentArea = { areaId, name, enable: enable === "true", tables: [] };
                    result.push(currentArea);
                } else {
                    currentArea.tables.push({ name });
                }
            }
            console.log('用餐區域桌號', result)
            return result.filter(area => area.enable);
        },
        categories: (state) => {
            const result = [];
            for (let i = 2; i < state.categoriesResponse.length; i++) {
                const [categoryId, categoryName, enable, ...categoryItems] = state.categoriesResponse[i];
                result.push({
                    categoryId,
                    categoryName,
                    enable: enable === 'true',
                    categoryItems: categoryItems.filter(item => item)
                });
            }
            return result.filter(category => {
                return category.enable && category.categoryId
            });
        },
        products: (state, getters) => {
            let data = [...state.productsResponse];
            const headers = data[1];
            const result = [];
            // 將 data 每個 row 長度都補齊與 headers 一樣長, 往後補將值設為 null
            data = data.map(row => {
                const diff = headers.length - row.length;
                if (diff > 0) {
                    for (let i = 0; i < diff; i++) {
                        row.push(null);
                    }
                }
                return row;
            });

            for (let i = 2; i < data.length; i++) {
                const item = {};
                const productSpecSettings = [];

                for (let index = 0; index < data[i].length; index++) {
                    const value = data[i][index];
                    const key = productKeyMap[headers[index]];

                    if (index >= 15) {
                        if (!value) {
                            index += 6;
                            continue;
                        }
                        productSpecSettings.push({
                            "subSpecID": value,
                            "mustHave": data[i][index + 1] ? getters.toBoolean(data[i][index + 1]) : false,
                            "frontEndDisplayName": data[i][index + 2],
                            "isSingleSelection": data[i][index + 3] ? getters.toBoolean(data[i][index + 3]) : false,
                            // 預設為 0
                            "multiSelectionMin": data[i][index + 4] ? Number(data[i][index + 4]) : 0,
                            // 預設為 1
                            "multiSelectionMax": data[i][index + 5] ? Number(data[i][index + 5]) : 1,
                            "allowSelectManyTimes": data[i][index + 6] ? getters.toBoolean(data[i][index + 6]) : false
                        });
                        index += 6;
                    } else {
                        if (key === 'autoReplenishCount') item[key] = value ? Number(value) : null;
                        else if (key === 'standardPrice') item[key] = value ? Number(value) : 0.0;
                        else if (key === 'availableInStore') item[key] = value ? getters.toBoolean(value) : false;
                        else if (key === 'cost') item[key] = value ? Number(value) : 0.0;
                        else if (key === 'isTaxFree') item[key] = value ? getters.toBoolean(value) : false;
                        // stockLimit 不需要
                        else if (key === 'stockLimit') continue
                        else if (key === 'vipPrice') item[key] = value ? Number(value) : item['standardPrice'];
                        else if (key === 'isDynamicPrice') item[key] = value ? getters.toBoolean(value) : false;
                        else if (key === 'stockMode') item[key] = value ? Number(value) : 0;
                        else {
                            // 使用表單資料
                            item[key] = value;
                        }
                    }
                }
                item["productSpecSettings"] = productSpecSettings;
                item['price'] = getters.isVip ? item['vipPrice'] : item['standardPrice'];
                result.push(item);
            }
            return result;
        },
        combos: (state, getters) => {
            let data = [...state.combosResponse];
            const headers = data[1];
            const result = [];
            // 將 data 每個 row 長度都補齊與 headers 一樣長, 往後補將值設為 null
            data = data.map(row => {
                const diff = headers.length - row.length;
                if (diff > 0) {
                    for (let i = 0; i < diff; i++) {
                        row.push(null);
                    }
                }
                return row;
            });

            for (let i = 2; i < data.length; i++) {
                const item = {};
                const productIDs = [];
                const comboSubSettings = [];
                let comboSubAnySetting = {};

                for (let index = 0; index < data[i].length; index++) {
                    const value = data[i][index];
                    const key = comboKeyMap[headers[index]];

                    if (index >= 16 && index <= 25) {
                        if (!value) {
                            continue;
                        }
                        productIDs.push(value);
                    } else if (index >= 26 && index <= 60) {
                        if (!value) {
                            index += 6;
                            continue;
                        }
                        comboSubSettings.push({
                            "subSpecID": value,
                            "mustHave": data[i][index + 1] ? getters.toBoolean(data[i][index + 1]) : false,
                            "frontEndDisplayName": data[i][index + 2],
                            "isSingleSelection": data[i][index + 3] ? getters.toBoolean(data[i][index + 3]) : false,
                            // 預設為 0
                            "multiSelectionMin": data[i][index + 4] ? Number(data[i][index + 4]) : 0,
                            // 預設為 1
                            "multiSelectionMax": data[i][index + 5] ? Number(data[i][index + 5]) : 1,
                            "allowSelectManyTimes": data[i][index + 6] ? getters.toBoolean(data[i][index + 6]) : false
                        });
                        index += 6;
                    } else if (index >= 61 && index <= 64) {
                        if (!value) {
                            continue;
                        }
                        comboSubAnySetting = {
                            "comboSubAnyID": value,
                            "frontEndDisplayName": data[i][index + 1],
                            "selectionCount": data[i][index + 2] ? Number(data[i][index + 2]) : 1,
                            "allowSelectManyTimes": data[i][index + 3] ? getters.toBoolean(data[i][index + 3]) : false
                        };
                        index += 3;
                    } else {
                        if (key === 'standardPrice') item[key] = value ? Number(value) : 0.0;
                        else if (key === 'availableInStore') item[key] = value ? getters.toBoolean(value) : false;
                        else if (key === 'cost') item[key] = value ? Number(value) : 0.0;
                        else if (key === 'isTaxFree') item[key] = value ? getters.toBoolean(value) : false;
                        else if (key === 'stockLimit') continue
                        // dailyAutoReplenish 不需要
                        else if (key === 'dailyAutoReplenish') continue
                        // unlimitedStock 不需要
                        else if (key === 'unlimitedStock') continue
                        else if (key === 'vipPrice') item[key] = value ? Number(value) : item['standardPrice'];
                        else if (key === 'isDynamicPrice') item[key] = value ? getters.toBoolean(value) : false;
                        else if (key === 'comboMode') item[key] = value ? Number(value) : 0;
                        else if (key === 'enable') item[key] = value ? getters.toBoolean(value) : false;
                        else if (key === 'altBasePrice') item[key] = value ? Number(value) : '';
                        else {
                            // 使用表單資料
                            item[key] = value;
                        }
                    }
                }

                item["productIDs"] = productIDs;
                item["comboSubSettings"] = comboSubSettings;
                item["comboSubAnySetting"] = comboSubAnySetting.comboSubAnyID ? comboSubAnySetting : null;
                item['price'] = getters.isVip ? item['vipPrice'] : item['standardPrice'];
                result.push(item);
            }
            return result;
        },
        productComboSpec: (state, getters) => {
            const headers = state.productComboSpecResponse[1];
            const result = [];
            // 將 data 每個 row 長度都補齊與 headers 一樣長, 往後補將值設為 null
            const data = state.productComboSpecResponse.map(row => {
                const diff = headers.length - row.length;
                if (diff > 0) {
                    for (let i = 0; i < diff; i++) {
                        row.push(null);
                    }
                }
                return row;
            })
            for (let i = 2; i < data.length; i++) {
                for (let index = 0; index < data[i].length; index += 7) {
                    let item = {
                        id: data[i][index],
                        mustHave: data[i][index + 1] ? getters.toBoolean(data[i][index + 1]) : false,
                        frontEndDisplayName: data[i][index + 2],
                        isSingleSelection: data[i][index + 3] ? getters.toBoolean(data[i][index + 3]) : false,
                        multiSelectionMin: data[i][index + 4] ? Number(data[i][index + 4]) : 0,
                        multiSelectionMax: data[i][index + 5] ? Number(data[i][index + 5]) : 1,
                        allowSelectManyTimes: data[i][index + 6] ? getters.toBoolean(data[i][index + 6]) : false,
                    }
                    result.push(item);
                }
            }
            console.log('全單規格', result)
            return result;
        },
        specifications: (state, getters) => {
            let data = [...state.specificationResponse];
            const headers = data[1];
            const result = [];
            // 將 data 每個 row 長度都補齊與 headers 一樣長, 往後補將值設為 null
            data = data.map(row => {
                const diff = headers.length - row.length;
                if (diff > 0) {
                    for (let i = 0; i < diff; i++) {
                        row.push(null);
                    }
                }
                return row;
            });

            for (let i = 2; i < data.length; i++) {
                const item = {};
                const specOptions = [];

                for (let index = 0; index < data[i].length; index++) {
                    const value = data[i][index];
                    const key = specificationKeyMap[headers[index]];

                    if (index >= 5) {
                        if (!value) {
                            index += 4;
                            continue;
                        }
                        specOptions.push({
                            "id": commonUtils.generateId(),
                            "name": value,
                            "price": data[i][index + 1] ? Number(data[i][index + 1]) : 0.0,
                            "unLimitStock": data[i][index + 2] ? getters.toBoolean(data[i][index + 2]) : false,
                            // stockLimit 不需要
                            // "stockLimit": data[i][index + 3] ? Number(data[i][index + 3]) : 0,
                            "dailyAutoRestock": data[i][index + 4] ? getters.toBoolean(data[i][index + 4]) : false,
                        });
                        index += 4;
                    } else {
                        if (key === 'enableForOrderSpec') item[key] = value ? getters.toBoolean(value) : false;
                        else if (key === 'enableForProductComboSpec') item[key] = value ? getters.toBoolean(value) : false;
                        // 使用表單資料
                        else item[key] = value;
                    }
                }
                item["specOptions"] = specOptions;
                result.push(item);
            }
            console.log('規格', result)
            return result;
        },
        comboSubItems: (state, getters) => {
            let data = [...state.comboSubItemsResponse];
            const headers = data[1];
            const result = []

            for (let i = 2; i < data.length; i++) {
                const item = {};
                const productIDs = [];

                for (let index = 0; index < data[i].length; index++) {
                    const value = data[i][index];
                    const key = comboSubItemsKeyMap[headers[index]];

                    if (index >= 6) {
                        productIDs.push(value);
                    } else {
                        if (key === 'enable') item[key] = value ? getters.toBoolean(value) : false;
                        else if (key === 'altBasePrice') item[key] = value ? Number(value) : 0.0;
                        else if (key === 'comboSubAltID') item[key] = value ? value : '';
                        else {
                            item[key] = value ? value : null;
                        }
                    }
                }
                item["productIDs"] = productIDs;
                result.push(item)
            }
            console.log('套餐子項', result)
            return result;
        },
        productAndComboList: (state, getters) => {
            return [...getters.products, ...getters.combos];
        },
        productsInCategory: (state, getters) => {
            return getters.categories
                .filter(category => category.enable)
                .map(category => {
                    let categoryItems = category.categoryItems.map(item => {
                        return getters.productAndComboList.find(product => product.id === item);
                    }).filter(item => item);
                    return {
                        category: category.categoryName,
                        products: categoryItems
                    };
                })
        },
        toBoolean: () => (value) => {
            return (/true/).test(value)
        },
        comboSubAny: (state, getters) => {
            let data = [...state.comboSubAnyResponse];
            const header = data[1];
            const result = [];
            for (let i = 2; i < data.length; i++) {
                const item = {}
                const productIDs = []

                for (let index = 0; index < data[i].length; index++) {
                    const value = data[i][index]
                    const key = comboSubAnyKeyMap[header[index]]

                    if (index >= 3) {
                        productIDs.push(value)
                    } else {
                        if (key === 'enable') item[key] = value ? getters.toBoolean(value) : false
                        else {
                            item[key] = value ? value : null
                        }
                    }
                }
                item["productIDs"] = productIDs
                result.push(item)
            }
            console.log('任選子項', result)
            return result
        },
        comboSubAltItems: (state, getters) => {
            let data = [...state.comboSubAltResponse];
            const header = data[1];
            const result = []
            for (let i = 2; i < data.length; i++) {
                const item = {}
                const productIDs = []

                for (let index = 0; index < data[i].length; index++) {
                    const value = data[i][index]
                    const key = comboSubAltKeyMap[header[index]]

                    if (index >= 3) {
                        productIDs.push(value)
                    } else {
                        if (key === 'enable') item[key] = value ? getters.toBoolean(value) : false
                        else {
                            item[key] = value ? value : null
                        }
                    }
                }
                item["productIDs"] = productIDs
                result.push(item)
            }
            console.log('替換子項', result)
            return result
        },
        spreadSheetTitles: (state) => {
            return state.spreadSheetData.sheetTitles
        }
    },
    mutations: {
        setDineInTables(state, payload) {
            state.dineInTablesResponse = payload;
            state.dineInTablesLoaded = true;
        },
        setCategories(state, payload) {
            state.categoriesResponse = payload;
        },
        setProducts(state, payload) {
            state.productsResponse = payload;
        },
        setCombs(state, payload) {
            state.combosResponse = payload;
        },
        setSpecifications(state, payload) {
            state.specificationResponse = payload;
        },
        setComboSubItems(state, payload) {
            state.comboSubItemsResponse = payload;
        },
        setComboSubAny(state, payload) {
            state.comboSubAnyResponse = payload;
        },
        setComboSubAlt(state, payload) {
            state.comboSubAltResponse = payload;
        },
        setSpreadSheetData(state, payload) {
            state.spreadSheetData = payload
        },
        setProductComboSpec(state, payload) {
            state.productComboSpecResponse = payload;
        },
        setDineInTablesLoaded(state, payload) {
            state.dineInTablesLoaded = payload
        }
    },
    actions: {
        // 清空資料
        async clearData({ commit }) {
            commit('setDineInTables', []);
            commit('setCategories', []);
            commit('setProducts', []);
            commit('setCombs', []);
            commit('setSpecifications', []);
            commit('setComboSubItems', []);
            commit('setComboSubAny', []);
            commit('setComboSubAlt', []);
            commit('setProductComboSpec', []);
            commit('setDineInTablesLoaded', false);
        },
        // 分類
        async getCategories({ commit, getters }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[0]);
            commit('setCategories', response.data.values);
        },
        // 套餐
        async getCombos({ commit, getters, dispatch }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[1]);
            commit('setCombs', response.data.values);

            // 套餐資料更新時重置商品描述載入狀態，確保描述資料與套餐資料同步
            dispatch('product/onProductDataUpdated', null, { root: true })
        },
        // 餐點
        async getProducts({ commit, getters, dispatch }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[2]);
            commit('setProducts', response.data.values);

            // 商品資料更新時重置商品描述載入狀態，確保描述資料與商品資料同步
            dispatch('product/onProductDataUpdated', null, { root: true })
        },
        // 規格
        async getSpecifications({ commit, getters }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[3]);
            commit('setSpecifications', response.data.values);
        },
        // 套餐子項
        async getComboSubItems({ commit, getters }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[4]);
            commit('setComboSubItems', response.data.values);
        },
        // 替換子項
        async getComboSubAlt({ commit, getters }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[5]);
            commit('setComboSubAlt', response.data.values);
        },
        // 任選子項
        async getComboSubAny({ commit, getters }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[6]);
            commit('setComboSubAny', response.data.values);
        },
        // 全單規格
        async getProductComboSpec({ commit, getters }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[7]);
            commit('setProductComboSpec', response.data.values);
        },
        // 用餐區域桌號
        async getDineInTables({ commit, getters }) {
            const response = await spreadsheetApi.getSpreadSheetDataBySheetName(getters.spreadSheetTitles[8]);
            commit('setDineInTables', response.data.values);
        },
        // 取得菜單頁籤資料
        async getSpreadSheetData({ commit }) {
            const spreadSheetMetaData = (await spreadsheetApi.getSpreadSheetMetaData()).data
            const spreadSheetData = new spreadSheetModel(spreadSheetMetaData)
            console.log('菜單頁籤資料', spreadSheetData)
            commit('setSpreadSheetData', spreadSheetData)
        }
    }
}
